import { Flex } from "@chakra-ui/react";
import { Header } from "components/Header";
import InputComp from "components/InputComp";
import PaginationComp from "components/PaginationComp";
import TableList from "components/TableList";
import { toaster } from "components/ui/toaster";
import { useEffect, useState } from "react";
import { api } from "services/api";
import utils from "utils";
import storage from "utils/storage";

const headers = [
  "Date",
  "Description",
  {
    label: "Admin",
    colW: "12ch",
    style: {
      textAlign: "end",
    },
  },
  {
    label: "Tax",
    colW: "10%",
    style: {
      textAlign: "end",
    },
  },
  {
    label: "Non-Refundable",
    colW: "12ch",
    style: {
      textAlign: "end",
    },
  },
  {
    label: "IN",
    colW: "12ch",
    style: {
      textAlign: "end",
    },
  },
  {
    label: "Out",
    colW: "12ch",
    style: {
      textAlign: "end",
    },
  },
  {
    label: "Balance",
    colW: "12ch",
    style: {
      textAlign: "end",
    },
  },
];

// const items = [
//   // {
//   //   id: 1,
//   //   Item: "200",
//   // },
// ];

function Statements() {
  const [isLoading, setIsLoading] = useState(false);
  const [list, setList] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [dealers, setDealers] = useState();

  const onDealerChange = ({ dealerid, page }) => {
    setIsLoading(true);
    api.getStatements({ dealerid, page }).then((res) => {
      console.log("getStatements res", res?.data);
      setIsLoading(false);
      if (res?.status === 200) {
        if (page) {
          setActivePage(page);
        }
        if (res?.data && res.data[0]) {
          setList(
            res.data.map((a, index) => ({
              id: `dealer-itm-${index}`,
              Date: a?.transdate ? utils.formatToDDMMYYYY(a.transdate) : "",
              Description: a.description,
              Admin: a.admin
                ? utils.formatAmountForTb(a.admin, "no-symbols")
                : "",
              Tax: a.tax ? utils.formatAmountForTb(a.tax, "no-symbols") : "",
              "Non-Refundable Agreements": a.rfnd
                ? utils.formatAmountForTb(a.rfnd, "no-symbols")
                : "",
              In: a.in ? utils.formatAmountForTb(a.in, "no-symbols") : "",
              Out: a.out ? utils.formatAmountForTb(a.out, "no-symbols") : "",
              Balance: a.balance
                ? utils.formatAmountForTb(a.balance, "no-symbols")
                : "",
            }))
          );
        } else {
          setList([]);
        }
      } else {
        toaster.create({
          title: res?.message,
          type: "error",
        });
      }
    });
  };

  const onDdChange = (data) => {
    setDealers([...data.list]);
    if (data?.item?.data?.dealerid || data?.item?.data?.dealerid === 0) {
      onDealerChange({ dealerid: data.item.data.dealerid });
    }

    const appcatch = storage.get("appcatch") || {};
    appcatch.statements_dealerid = data?.item?.data?.dealerid;
    storage.set("appcatch", appcatch);
  };

  // useEffect(() => {
  //   setIsLoading(true);
  //   api.getDealers().then((res) => {
  //     console.log('getDealers', res);
  //     setIsLoading(false);
  //     if (res?.status === 200) {
  //       if (res?.data && res?.data[0]) {
  //         let dea = [];

  //         dea = res.data.map((a, index) => ({
  //           key: `dealer-${index}`,
  //           value: `${a.companyname}-${index}`,
  //           label: a.companyname,
  //           data: { dealerid: a.dealerid },
  //         }));

  //         const arr = [
  //           // {
  //           //   key: "dealer-all",
  //           //   value: "all",
  //           //   label: "All",
  //           //   data: { dealerid: 0 },
  //           // },
  //           ...dea,
  //         ];
  //         arr[0].selected = true;

  //         setDealers(arr);
  //         onDealerChange({ dealerid: arr[0]?.data?.dealerid });
  //       }
  //     } else {
  //       toaster.create({
  //         title: res?.message,
  //         type: "error",
  //       });
  //     }
  //   });
  // }, []);

  const onChangePage = (data) => {
    if (data.page === activePage) {
      return;
    }
    onDealerChange({
      page: data.page,
      dealerid: utils.getDealerid(dealers),
    });
  };

  useEffect(() => {
    const cb = async () => {
      const appcatch = storage.get("appcatch") || {};
      await utils.getDealers({
        setIsLoading,
        action: "useState",
        onDealersChange: onDdChange,
        allOption: false,
        defaultVal: appcatch?.statements_dealerid,
      });
    };
    cb();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Flex direction={"column"} mb={"1rem"}>
        <Header label={"Statements"} isLoading={isLoading} />
        <InputComp
          // <DropDown
          type={"dropdown"}
          items={dealers}
          onChange={onDdChange}
          placeholder={"Select Account"}
        />
      </Flex>
      <TableList
        type={"simple"}
        headers={headers}
        items={list}
        // colGroup={colGroup}
      />
      <PaginationComp
        // pageSize={10}
        itemsLength={list?.length}
        activePage={activePage}
        onChange={onChangePage}
      />
    </Flex>
  );
}

export default Statements;
